module.exports = __webpack_public_path__ + "static/media/pizza-how-it-works.d1e910d8.jpg";